export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "Web Development", link: "/web-development" },
      { title: "Mobile Development", link: "/mobile-development" },
      { title: "Machine Learning", link: "/machine-learning" },
      { title: "Computer Science", link: "/computer-science" },
      { title: "Developer Tools", link: "/developer-tools" },
      { title: "IT", link: "/it" },
      
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "C/C++", link: "/c++" },
      { title: "Java", link: "/java" },
      { title: "JavaScript", link: "/javascript" },
      { title: "HTML & CSS", link: "/html-css" },
      { title: "Python", link: "/python" },
      { title: "SQL", link: "/sql" },
      
    ],
  },
  {
    title: "Career building",
    links: [
      { title: "Career paths", link: "/career-paths" },
      { title: "Career services", link: "/career-services" },
      { title: "Interview prep", link: "/interview-prep" },
      {
        title: "Professional certification",
        link: "/professional-certification",
      },
      { title: "Full Catalog", link: "/full-catalog" },
      { title: "Beta Content", link: "/beta-content" },
    ],
  },
];
